module.exports = __webpack_public_path__ + "media/Images/psivet-home-banner-001-compressed-004c80fb1f60d183a34a9c55ed1e9de5.jpg";